import axios from 'axios'
import React from 'react'
import './todo.scss'
const Todo = ({todo,settodos,setLoading}) => {


  const updateStatus = async()=>{
    try{
      setLoading(true);
      const {data} = await axios.patch(`/api/todo/update/${todo._id}`,{},{withCredentials:true});
      settodos((prevTodo)=>{
        return prevTodo.map((item)=>{
          if(item._id === data.todo._id) return data.todo
          return item
        })
      })
      setLoading(false)
    }
    catch(err){
      setLoading(false)
      console.log(err.msg)
    }

  }
  const handleDelete  = async()=>{
    try{
      setLoading(true)
      const {data} =await  axios.delete(`/api/todo/delete/${todo._id}`,{withCredentials:true});
      setLoading(false)
      settodos((prev)=>{
        return prev.filter((item)=>{
          return item._id !== data.todo._id
        })
      })
    }
    catch(err){
      setLoading(false)
      console.log(err.response.data.msg)
    }
  }
  return (
    <div className='todo-item'>
      <p className='task' onClick={updateStatus} style={{textDecoration:todo.status === "pending" ? "none" : "line-through"}}>{todo.task}</p>
      <button onClick={handleDelete}>DELETE</button>
    </div>
  )
}

export default Todo